import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { FilterState } from './reducer'
import * as qs from 'query-string'

export function useUrlSync(state: FilterState) {
  const router = useRouter()
  const { style, size, material, dial, page } = state

  useEffect(() => {
    let query = {}
    if (style && style.length) {
      query['style'] = style
    }
    if (size && size.length) {
      query['size'] = size
    }
    if (material && material.length) {
      query['material'] = material
    }
    if (dial && dial.length) {
      query['dial'] = dial
    }
    if (page && page > 0) {
      query['page'] = page.toString()
    }

    const str = qs.stringify(query, { arrayFormat: 'comma' })
    const currentUrl = `${window.location.host}${window.location.search}`
    const newUrl = `${window.location.host}?${str}`

    if (currentUrl !== newUrl) {
      router.replace(
        router.pathname,
        `${window.location.pathname}${str.length ? `?${str}` : ''}`,

        {
          shallow: true
        }
      )
    }
  }, [style, size, material, dial, page]) // eslint-disable-line
}
